import { Autocomplete, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

interface IFormInput {
    name: string;
    label: string;
    control: any;
    error: any;
    disabled?: boolean;
    options: { value: string | number; label: string }[];
    concatWithID?: boolean;
    limitTags?: number;
    filterOptions?: any;
    onChange?: any;
    disableCloseOnSelect?: boolean;
}

export default function AutoCompleteComponent({
    name,
    label,
    options,
    control,
    error,
    disabled,
    concatWithID: concat,
    onChange,
    limitTags,
    filterOptions,
    disableCloseOnSelect,
}: IFormInput) {
    // Garante sempre um array — backend fora/cold start pode entregar undefined.
    const safeOptions = Array.isArray(options) ? options : [];

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={[]}
            render={({ field: { onChange: renderChange, value: valueProp } }) => {
                return (
                    <Autocomplete
                        openText="Abrir"
                        closeText="Fechar"
                        multiple
                        size="small"
                        limitTags={limitTags}
                        disabled={disabled}
                        options={safeOptions}
                        filterOptions={filterOptions}
                        disableCloseOnSelect={disableCloseOnSelect}
                        value={valueProp || []}
                        getOptionLabel={(opt) => {
                            if (concat) {
                                if (typeof opt === "object") {
                                    return `${opt?.value} - ${opt?.label}`;
                                }
                                if (typeof opt === "string") {
                                    return safeOptions.find((op) => String(op.value) === String(opt))?.label || opt;
                                }
                            }

                            return (
                                (opt as any)?.label ||
                                safeOptions.find((op) => String(op.value) === String(opt))?.label ||
                                opt ||
                                ""
                            );
                        }}
                        isOptionEqualToValue={(option, value) => {
                            return String(option.value) === String(value);
                        }}
                        renderOption={(optionProps, option: any) => (
                            // Key única pelo `value` — rótulos repetidos geram keys
                            // duplicadas e o React deixa <li> fantasma ao filtrar.
                            <li {...optionProps} key={`${option?.value}-${option?.label}`}>
                                {concat ? `${option?.value} - ${option?.label}` : option?.label}
                            </li>
                        )}
                        onChange={(_, value) => {
                            const newValue = !!value
                                ? value.map((opt) => {
                                      const isNewValueString = typeof opt === "string";
                                      return isNewValueString ? opt : String(opt.value);
                                  })
                                : [];
                            renderChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                margin="normal"
                                size="small"
                                error={!!error && !!error[name]}
                                helperText={!!error && error[name]?.message}
                                label={label}
                                placeholder={label}
                            />
                        )}
                    />
                );
            }}
        />
    );
}
